import { useFormik } from "formik";
import validations from "../validations/createDayoffFormValidations";
import {
  useFetchDayoffTypeDocumentsQuery,
  useFetchGetDayoffTypesQuery,
  useFetchGetUsersQuery,
  usePostDayoffMutation,
  useFetchMeQuery,
} from "../../../store";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import CustomSelect from "../../../components/shared/CustomSelect";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "../../../store/slices/dialog/dialogSlice";
import { CREATE_DAYOFF } from "../../../store/slices/utils/dialogEnum";
import Loading from "../../../components/shared/Loading";
import Button from "@mui/material/Button";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../store/slices/toast/toastSlice";
import CustomDatePicker from "../../../components/shared/CustomDatePicker";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import TextField from "@mui/material/TextField";
import CustomFileInput from "../../../components/shared/CustomFileInput";
import Stack from "@mui/material/Stack";
import FormHelperText from "@mui/material/FormHelperText";
import Alert from "@mui/material/Alert";

const CreateDayoffForm = () => {
  const dispatch = useDispatch();

  const { createDayoffOpen } = useSelector((state) => state.dialogSlice);

  const handleClose = () => {
    dispatch(closeDialog(CREATE_DAYOFF));
  };

  const { data: dayoffTypes, isLoading: dayoffTypeLoading } =
    useFetchGetDayoffTypesQuery();
  const { data: users, isLoading: usersLoading } = useFetchGetUsersQuery();
  const { data: user } = useFetchMeQuery();

  // Cinsiyete göre izin türlerini filtrele
  // genderId: 1 = Erkek, 2 = Kadın varsayılmıştır
  const filteredDayoffTypes = dayoffTypes?.data?.filter((type) => {
    const name = type.dayoffTypeName.toLowerCase();
    if (user?.genderId === 1 && name.includes("doğum")) return false; // Erkekse doğum izni olmasın
    if (user?.genderId === 2 && name.includes("babalık")) return false; // Kadınsa babalık izni olmasın
    return true;
  });

  const [postDayoff, { isLoading: postDayoffLoading }] =
    usePostDayoffMutation();

  const handleChangeDate = ({ name, value }) => {
    const day = new Date(value).getDay();
    if (day === 6 || day === 0) {
      dispatch(openErrorToast("Hafta İçi Seçim Yapınız !"));
      formik.setFieldValue(name, dayjs(null).format("YYYY-MM-DD"));
    } else {
      var date = value ? dayjs(value).format("YYYY-MM-DD") : null;
      formik.setFieldValue(name, date);
      if (formik.values.isHalfDay) {
        formik.setFieldValue("endDate", date);
      }
    }
  };

  const handleChangeHalfDay = (e) => {
    const isHalfDay = e.target.checked;
    if (isHalfDay) {
      formik.setFieldValue("endDate", formik.values.startDate);
    }
    formik.setFieldValue(e.target.name, e.target.checked);
  };

  const handleChangeFile = (e) => {
    formik.setFieldValue("files", [
      ...formik.values.files,
      { documentTypeId: e.target.name, file: e.target.files[0] },
    ]);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: 0,
      dayoffTypeId: 0,
      startDate: dayjs().format("YYYY-MM-DD"),
      endDate: dayjs().format("YYYY-MM-DD"),
      dayoffLocation: "",
      proxyUserId: 0,
      dayoffDescription: "",
      isHalfDay: false,
      files: [],
    },
    validationSchema: validations,
    onSubmit: async (values, bag) => {
      try {
        const formData = new FormData();
        formData.append("id", values.id);
        formData.append("dayoffTypeId", parseInt(values.dayoffTypeId));
        formData.append("startDate", values.startDate);
        formData.append("endDate", values.endDate);
        formData.append("dayoffLocation", values.dayoffLocation);
        formData.append(
          "proxyUserId",
          values.proxyUserId !== "" && values.proxyUserId !== null
            ? parseInt(values.proxyUserId)
            : 0
        );
        formData.append("dayoffDescription", values.dayoffDescription);
        formData.append("isHalfDay", values.isHalfDay.toString());
        formData.append("id", values.id);
        if (values.files.length !== 0) {
          for (let index = 0; index < values.files.length; index++) {
            formData.append(
              `files[${index}].documentTypeId`,
              values.files[index].documentTypeId
            );
            formData.append(`files[${index}].file`, values.files[index].file);
          }
        }
        const response = await postDayoff({ dayoff: formData, id: values.id });

        if (!response?.data?.isSuccess) {
          bag.setErrors({ general: response.data.message });
        } else {
          openSuccessToast("İzin Oluşturuldu !");
          handleClose();
        }
      } catch (error) {
        bag.setErrors({ general: error.response.data.message });
      }
    },
  });
  const { data: documents, isLoading: documentsLoading } =
    useFetchDayoffTypeDocumentsQuery(formik.values.dayoffTypeId);
  if (dayoffTypeLoading || usersLoading || documentsLoading)
    return (
      <Loading
        isLoading={dayoffTypeLoading || usersLoading || documentsLoading}
      />
    );
  return (
    <Modal
      open={createDayoffOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          İzin Talebi Oluştur
        </Typography>
        <Box id="modal-modal-description" sx={{ mt: 2 }}>
          {formik.errors.general && (
            <Box textAlign="center" sx={{ mb: 2 }}>
              <Alert severity="error">{formik.errors.general}</Alert>
            </Box>
          )}
          <form onSubmit={formik.handleSubmit}>
            <FormControl
              fullWidth
              sx={{ m: 1 }}
              error={
                formik.touched.dayoffTypeId &&
                Boolean(formik.errors.dayoffTypeId)
              }
            >
              <InputLabel id="dayoffTypeId-label">İzin Türü</InputLabel>
              <CustomSelect
                data={filteredDayoffTypes}
                id="dayoffTypeId"
                value={formik.values.dayoffTypeId}
                handleChange={formik.handleChange}
              />
              {formik.touched.dayoffTypeId && (
                <FormHelperText>{formik.errors.dayoffTypeId}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              sx={{ m: 1 }}
              error={
                formik.touched.startDate && Boolean(formik.errors.startDate)
              }
            >
              <CustomDatePicker
                handleChange={handleChangeDate}
                value={formik.values.startDate}
                id="startDate"
                label={"Başlangıç Tarihi"}
              />
              {formik.touched.startDate && (
                <FormHelperText>{formik.errors.startDate}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              sx={{ m: 1 }}
              error={formik.touched.endDate && Boolean(formik.errors.endDate)}
            >
              <CustomDatePicker
                handleChange={handleChangeDate}
                value={formik.values.endDate}
                id="endDate"
                label={"Bitiş Tarihi"}
              />
              {formik.touched.endDate && (
                <FormHelperText>{formik.errors.endDate}</FormHelperText>
              )}
            </FormControl>
            <FormGroup sx={{ m: 1 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    value={formik.values.isHalfDay}
                    onChange={handleChangeHalfDay}
                    id="isHalfDay"
                    name="isHalfDay"
                    color="secondary"
                  />
                }
                label="Yarım Gün İzin"
              />
            </FormGroup>
            <FormControl fullWidth sx={{ m: 1 }}>
              <TextField
                id="dayoffLocation"
                name="dayoffLocation"
                error={
                  formik.touched.dayoffLocation &&
                  Boolean(formik.errors.dayoffLocation)
                }
                label="İzin Günü Konumu"
                value={formik.values.dayoffLocation}
                onChange={formik.handleChange}
                helperText={
                  formik.touched.dayoffLocation && formik.errors.dayoffLocation
                }
              />
            </FormControl>
            <FormControl
              fullWidth
              sx={{ m: 1 }}
              error={
                formik.touched.proxyUserId && Boolean(formik.errors.proxyUserId)
              }
            >
              <InputLabel id="proxyUserId-label">Vekil Kullanıcı</InputLabel>
              <CustomSelect
                data={users?.data}
                id="proxyUserId"
                value={formik.values.proxyUserId}
                handleChange={formik.handleChange}
              />
              {formik.touched.proxyUserId && (
                <FormHelperText>{formik.errors.proxyUserId}</FormHelperText>
              )}
            </FormControl>
            <FormControl fullWidth sx={{ m: 1 }}>
              <TextField
                id="dayoffDescription"
                label="İzin Açıklaması"
                multiline
                rows={4}
                value={formik.values.dayoffDescription}
                onChange={formik.handleChange}
              />
            </FormControl>
            {documents?.data.length > 0 &&
              documents?.data.map((document) => (
                <FormControl
                  fullWidth
                  sx={{ m: 1 }}
                  key={document.documentName}
                >
                  <CustomFileInput
                    contentName={document.documentName}
                    onChange={handleChangeFile}
                    name={document.documentTypeId}
                    required={document.isRequired}
                  />
                </FormControl>
              ))}
            <Stack
              direction="row"
              spacing={2}
              sx={{ m: 1, justifyContent: "flex-end" }}
            >
              <Button
                type="button"
                onClick={handleClose}
                variant="contained"
                loading={postDayoffLoading}
                loadingPosition="end"
                color="error"
                startIcon={<CancelIcon />}
              >
                Vazgeç
              </Button>
              <Button
                loading={postDayoffLoading}
                variant="contained"
                loadingPosition="end"
                type="submit"
                color="success"
                startIcon={<SaveIcon />}
              >
                Kaydet
              </Button>
            </Stack>
          </form>
        </Box>
      </Box>
    </Modal>
  );
};

export default CreateDayoffForm;
